import { useMemo } from "react";
import { NavigateFunction, NavigateOptions, useNavigate } from "react-router-dom";
import { getClientService } from "services/client.service";

export const useMainNavigate = () => {
  const navigate = useNavigate();
  return useMemo(
    () =>
      ((url: string, options?: NavigateOptions) =>
        navigate(
          typeof url === "string" ? `/${getClientService().clientId}/${url.replace(/^\/+/, "")}` : url,
          options,
        )) as NavigateFunction,
    [navigate],
  );
};
